export abstract class SelectionVisuals {
	// eslint-disable-next-line @typescript-eslint/ban-types
	public abstract props: {};
	public abstract animateSelection(): void;
	public abstract animateDeselection(): void;
}
